import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCoProductsPerCooperative, getCultures } from 'services/API/Cooperative';
import { toast } from 'react-toastify';
import { displayErrorMessage } from 'utils/tools_functions';
import DataGridCulture from './DataGridCulture';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

const CulturesDataGridCooperative = ({
  user,
  cooperativeId,
  cooperativeName,
  economicAttribute,
  setEconomicAttribute,
  nitrogenCover,
  nitrogenSupplyByCoverOrganic,
  biomassSupplyByCover,
  setBiomassSupplyByCover,
  setCooperativeCulturesAtIndexLevel,
  loadDataFromParent,
}) => {
  const [coProductsList, setCoProductsList] = useState(null);
  const [cooperativeCultures, setCooperativeCultures] = useState(null);
  const { t } = useTranslation();

  const { isOrganic } = useToggleSwitch(
    'cooperatives',
    'cultures',
    () => {},
    cooperativeId,
    null,
    null
  );

  useEffect(() => {
    loadData(isOrganic);
  }, []);

  const loadData = (isOrganic) => {
    getCoProducts();
    getCooperativeCultures(isOrganic, cooperativeId);
  };

  const getCooperativeCultures = async (isOrganic, cooperativeId) => {
    try {
      const result = await getCultures(cooperativeId, isOrganic);
      const data = result.data;
      setCooperativeCultures(data);
      setCooperativeCulturesAtIndexLevel(data.data.sort((a, b) => a.name.localeCompare(b.name)));
    } catch (error) {
      toast.error(displayErrorMessage('ERR_GET_CULTURE'));
    }
  };

  const getCoProducts = async () => {
    let cooperativeId = null;
    if (user?.role === 'SUPER_ADMIN') {
      cooperativeId = Number(localStorage.getItem('cooperative'));
    }
    try {
      const result = await getCoProductsPerCooperative(cooperativeId);
      const { data } = result.data;
      setCoProductsList([{ id: null, displayName: t('common.none') }].concat(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <DataGridCulture
      columnsDefinition={cooperativeCultures?.metadata}
      from={'fromCooperative'}
      cultures={cooperativeCultures?.data}
      refreshData={loadData}
      user={user}
      coProductsList={coProductsList}
      cooperativeId={cooperativeId}
      economicAttribute={economicAttribute}
      setEconomicAttribute={setEconomicAttribute}
      cooperativeName={cooperativeName}
      nitrogenCover={nitrogenCover}
      nitrogenSupplyByCoverOrganic={nitrogenSupplyByCoverOrganic}
      getOffCropSettings={loadDataFromParent}
      biomassSupplyByCover={biomassSupplyByCover}
      setBiomassSupplyByCover={setBiomassSupplyByCover}
    />
  );
};

export default CulturesDataGridCooperative;
